import { property } from 'cosmos-config/generator';

const reminderUserProperties = [
  property('Name', 'name').informational(),
  property('Email', 'email').informational(),
  property('PrincipalId', 'principalId').excludeTable(),
];

export default reminderUserProperties;
